<template>
    <!--编辑页面-->
    <Drawer
            title="编辑"
            v-model="workOrderEditModel"
            :footer-hide="true"
            :mask-closable="true"
            @on-close='closeWorkEditPage'
            className="customDrawerStyleScwf"
            width="612"
            :styles="styles">
            <div style = "padding:0 20px;">
                <objectAddOrEdit
                        ref='objectAddOrEdit'
                        v-if='objectAddOrEditCon'
                        style='padding-bottom:55px;'
                        :data="objectAddOrEditData"
                        @on-success="_submitSuccess"
                        @on-fail="_submitFail"
                        objType = "sccm"
                >
                </objectAddOrEdit>
        </div>
        <div class="button-drawer-footer" >
            <Button type="primary" @click="editWorkOrderSave()">保存</Button>
            <Button @click="closeWorkEditPage" style="margin-left:10px">取消</Button>
            <Spin size="large" fix v-if="editWorkOrderSpan"></Spin>
        </div>
    </Drawer>
</template>

<script>

    export default {
        name: "scwfWorkOrderEdit1",
        data() {
            return {
                styles: {
                    height: 'calc(100% - 55px)',
                    overflow: 'auto',
                    paddingBottom: '53px',
                    position: 'static'
                },
                curstyles: {
                    height: 'calc(100% - 51px)',
                    overflow: 'auto',
                    paddingBottom: '51px',
                    position: 'static',
                    paddingTop: '0',
                    paddingRight: '0'
                },
                workOrderEditModel: false,
                objectAddOrEditCon: false,
                editWorkOrderSpan: false,
                objectAddOrEditData: {},
                currentRow: {},
                calBackFunction: null,
            }
        },
        methods: {
            editWorkOrderSave() {
                this.editWorkOrderSpan = true;
				this.$refs['objectAddOrEdit'].getFormData('customFormData').then(customFiled=>{
					console.log('111',customFiled)
                    if (customFiled.returnCode === '0') {
                        this.$refs['objectAddOrEdit'].customSubmit();
                    }else {
                        this.editWorkOrderSpan = false;
                    }
                })
                /*var customFiled = this.$refs['objectAddOrEdit'].getFormData('customFormData');
                if (customFiled.returnCode === '0') {
                    this.$refs['objectAddOrEdit'].customSubmit();
                }else {
                    this.editWorkOrderSpan = false;
                }*/

            },
            closeWorkEditPage() {
                this.$refs['objectAddOrEdit'].cancel();
                this.objectAddOrEditCon = false;
                this.workOrderEditModel = false;
                this.editWorkOrderSpan = false;
                this.calBackFunction = null;
            },
            _submitSuccess() {
                if (this.calBackFunction != null) {
                    this.calBackFunction();
                }
                this.closeWorkEditPage();
            },
            _submitFail() {
                this.editWorkOrderSpan = false;
            }
        },
        mounted() {
            this.$eventBus.on('dynamicComponent/call/objectEditDrawer', ({moId, row, calBackFun}) => {
                console.log("moId,row,calBackFun", moId, row, calBackFun)
                this.workOrderEditModel = true;
                if (this.objectAddOrEditCon) {
                    this.objectAddOrEditCon = false;
                }
                this.objectAddOrEditCon = true;
                if (calBackFun) {
                    this.calBackFunction = calBackFun;
                }
                this.objectAddOrEditData.tenantId = row.tenant_id_id;
                this.$set(this.objectAddOrEditData, 'moId', moId);
                this.$set(this.objectAddOrEditData, 'rowId', row.row_id);
                this.$set(this.objectAddOrEditData, 'mtId', row.mt_id);
                this.$set(this.objectAddOrEditData, 'busType', row.business_type_id);
                this.$set(this.objectAddOrEditData, 'isFlowType', '0');
                this.$set(this.objectAddOrEditData, 'modelId', '');
                this.$set(this.objectAddOrEditData, 'taskId', '');
                this.currentRow = row;

            })
        }
    }
</script>

<style scoped>
.button-drawer-footer{
    position:fixed;
    width:612px;
    right:0;
    bottom:0;
    left: inherit;
    z-index: 1;
    padding-right:36px;
}
</style>